import styled from 'styled-components';

export const CommunityWrapper = styled.div `
  width:100%;
  margin:0 auto;
  background: #fff;
  padding:2rem 4%;
`